import { render, staticRenderFns } from "./trainReviewed.vue?vue&type=template&id=ba8c131c"
import script from "./trainReviewed.vue?vue&type=script&lang=js"
export * from "./trainReviewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports